import React, {useState} from 'react'
import {ReactComponent as BookmarkIcon} from '../components/svgs/bookmarkicon.svg';
import {ReactComponent as BagIcon} from '../components/svgs/bagicon.svg';
import {ReactComponent as ScaleIcon} from '../components/svgs/scaleicon.svg';
import {ReactComponent as LaundryIcon} from '../components/svgs/laundrymachineicon.svg';
import {ReactComponent as ShippingIcon} from '../components/svgs/shippingboxicon.svg';


const SideCard = () => {

    const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: 'In Laundry',
      icon: <LaundryIcon/>,
      pastDue: 
        { orders: '16', bags: '98', size: '119' },
      dueToday: 
        { orders: '12', bags: '98', size: '119' },
      dueTomorrow: 
        { orders: '1', bags: '8', size: '59' },
      laterThanTomorrow: 
        { orders: '0', bags: '18', size: '159' },
    },
    {
      title: 'Ready for pickup',
      icon: <ShippingIcon/>,
      pastDue: 
        { orders: '16', bags: '98', size: '119' },
      dueToday: 
        { orders: '16', bags: '98', size: '119' },
      dueTomorrow: 
        { orders: '16', bags: '98', size: '119' },
      laterThanTomorrow: 
        { orders: '10', bags: '118', size: '49' },
    },
 
  ];

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div className='side-card-container'>
        <div className="tab-container">
            <div className="tab-titles side-tab-titles">
                {tabs.map((tab, index) => (
                <div
                    key={index}
                    className={`side-card-title ${activeTab === index ? 'active' : ''}`}
                    onClick={() => handleTabClick(index)}
                >
                    {/* <div className="tab-icon">{tab.icon}</div> */}
                    <div className={`tab-icon ${activeTab === index ? 'active' : ''}`}>
                        {React.cloneElement(tab.icon, {
                        className: activeTab === index ? 'active-icon' : ''
                        })}
                    </div>
                    <div className="tab-label">{tab.title}</div>
                </div>
                ))}
            </div>
            <div className='divider ml-3.5'></div>
            <div className="tab-content">
                {tabs.map((tab, index) => (
                <div key={index} className={`tab-pane ${activeTab === index ? 'active' : ''}`}>
                    <div className='flex flex-col gap-4'>
                        <div className='flex flex-col gap-8'>
                            <p className='side-card-title'>Past due</p>
                            <div className='flex gap-4'>
                                <BookmarkIcon/>
                                <p className='side-card-subtitle'>
                                {tab.pastDue.orders === '1' ? (
                                    <>
                                    {tab.pastDue.orders} <span className="order-text">order</span>
                                    </>
                                ) : (
                                    <>
                                    {tab.pastDue.orders} <span className="orders-text">orders</span>
                                    </>
                                )}
                                </p>


                            </div>
                            <div className='flex gap-4'>
                                <BagIcon/>
                                <p className='side-card-subtitle'>
                                {tab.pastDue.bags === '1' ? (
                                    <>
                                    {tab.pastDue.bags} <span className="order-text">bag</span>
                                    </>
                                ) : (
                                    <>
                                    {tab.pastDue.bags} <span className="orders-text">bags</span>
                                    </>
                                )}
                                </p>
                            </div>
                            <div className='flex gap-4'>
                                <ScaleIcon/>
                                <p className='side-card-subtitle'>{tab.pastDue.size} <span> lbs</span></p> 
                            </div>
                        </div>
                        <div className='divider mt-5'></div>
                        <div className='flex flex-col gap-8'>
                            <p className='side-card-title'>Due today</p>
                            <div className='flex gap-4'>
                                <BookmarkIcon/>
                               {/* <p className='side-card-subtitle'>{tab.dueToday.orders} <span> orders</span></p>  */}
                               <p className='side-card-subtitle'>
                                {tab.dueToday.orders === '1' ? (
                                    <>
                                    {tab.dueToday.orders} <span className="order-text">order</span>
                                    </>
                                ) : (
                                    <>
                                    {tab.dueToday.orders} <span className="orders-text">orders</span>
                                    </>
                                )}
                                </p>
                            </div>
                            <div className='flex gap-4'>
                                <BagIcon/>
                                {/* <p className='side-card-subtitle'>{tab.dueToday.bags} <span>bags</span> </p>  */}
                                <p className='side-card-subtitle'>
                                {tab.dueToday.bags === '1' ? (
                                    <>
                                    {tab.dueToday.bags} <span className="order-text">bag</span>
                                    </>
                                ) : (
                                    <>
                                    {tab.dueToday.bags} <span className="orders-text">bags</span>
                                    </>
                                )}
                                </p>
                            </div>
                            <div className='flex gap-4'>
                                <ScaleIcon/>
                                <p className='side-card-subtitle'>{tab.dueToday.size} <span> lbs</span></p> 
                            </div>
                        </div>
                        <div className='divider mt-5'></div>
                        <div className='flex flex-col gap-8'>
                            <p className='side-card-title'>Due tomorrow</p>
                            <div className='flex gap-4'>
                                <BookmarkIcon/>
                                {/* <p className='side-card-subtitle'>{tab.dueTomorrow.orders <= 1 ? `${tab.dueTomorrow.orders}` : `${tab.dueTomorrow.orders}` } <span> order</span> </p>  */}
                                <p className='side-card-subtitle'>
                                {tab.dueTomorrow.orders === '1' ? (
                                    <>
                                    {tab.dueTomorrow.orders} <span className="order-text">order</span>
                                    </>
                                ) : (
                                    <>
                                    {tab.dueTomorrow.orders} <span className="orders-text">orders</span>
                                    </>
                                )}
                                </p>
                            </div>
                            <div className='flex gap-4'>
                                <BagIcon/>
                                {/* <p className='side-card-subtitle'>{tab.dueTomorrow.bags} <span> bags</span></p>  */}
                                <p className='side-card-subtitle'>
                                {tab.dueTomorrow.bags === '1' ? (
                                    <>
                                    {tab.dueTomorrow.bags} <span className="order-text">bag</span>
                                    </>
                                ) : (
                                    <>
                                    {tab.dueTomorrow.bags} <span className="orders-text">bags</span>
                                    </>
                                )}
                                </p>
                            </div>
                            <div className='flex gap-4'>
                                <ScaleIcon/>
                                <p className='side-card-subtitle'>{tab.dueTomorrow.size} <span>lbs</span> </p> 
                            </div>
                        </div>

                        <div className='divider mt-5'></div>
                        <div className='flex flex-col gap-8'>
                            <p className='side-card-title'>Later than tomorrow</p>
                            <div className='flex gap-4'>
                                <BookmarkIcon/>
                                {/* <p className='side-card-subtitle'>{tab.dueTomorrow.orders <= 1 ? `${tab.dueTomorrow.orders}` : `${tab.dueTomorrow.orders}` } <span> order</span> </p>  */}
                                <p className='side-card-subtitle'>
                                {tab.laterThanTomorrow.orders === '1' ? (
                                    <>
                                    {tab.laterThanTomorrow.orders} <span className="order-text">order</span>
                                    </>
                                ) : (
                                    <>
                                    {tab.laterThanTomorrow.orders} <span className="orders-text">orders</span>
                                    </>
                                )}
                                </p>
                            </div>
                            <div className='flex gap-4'>
                                <BagIcon/>
                                {/* <p className='side-card-subtitle'>{tab.dueTomorrow.bags} <span> bags</span></p>  */}
                                <p className='side-card-subtitle'>
                                {tab.laterThanTomorrow.bags === '1' ? (
                                    <>
                                    {tab.laterThanTomorrow.bags} <span className="order-text">bag</span>
                                    </>
                                ) : (
                                    <>
                                    {tab.laterThanTomorrow.bags} <span className="orders-text">bags</span>
                                    </>
                                )}
                                </p>
                            </div>
                            <div className='flex gap-4'>
                                <ScaleIcon/>
                                <p className='side-card-subtitle'>{tab.laterThanTomorrow.size} <span>lbs</span> </p> 
                            </div>
                        </div>

                    </div>
                </div>
                ))}
            </div>
        </div>
    </div>
  )
}

export default SideCard